import type { IconNode } from '../types';

/**
 * @name mask-snorkel
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTMuNSAxNGEyIDIgMCAwIDEtMS40LS42bC0uNy0uOGMtLjgtLjgtMi0uOC0yLjggMGwtLjcuOGEyIDIgMCAwIDEtMS40LjZINmE0IDQgMCAwIDEgMC04aDhhNCA0IDAgMCAxIDAgOFoiIC8+CiAgPHBhdGggZD0iTTEyIDE4YTIgMiAwIDAgMS00IDAiIC8+CiAgPHBhdGggZD0iTTEwIDIwYTIgMiAwIDAgMCAyIDJoNGMzLjMgMCA2LTIuNyA2LTZWMmgtNHYxNGEyIDIgMCAwIDEtMiAyIiAvPgogIDxwYXRoIGQ9Ik0xOCAxMGg0IiAvPgogIDxjaXJjbGUgY3g9IjQuNSIgY3k9IjIxLjUiIHI9Ii41IiAvPgogIDxwYXRoIGQ9Ik0zIDE3LjVoLjAxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/mask-snorkel
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const maskSnorkel: IconNode = [
  [
    'path',
    {
      d: 'M13.5 14a2 2 0 0 1-1.4-.6l-.7-.8c-.8-.8-2-.8-2.8 0l-.7.8a2 2 0 0 1-1.4.6H6a4 4 0 0 1 0-8h8a4 4 0 0 1 0 8Z',
      key: 'd4n2z0',
    },
  ],
  ['path', { d: 'M12 18a2 2 0 0 1-4 0', key: 'u2gl7o' }],
  ['path', { d: 'M10 20a2 2 0 0 0 2 2h4c3.3 0 6-2.7 6-6V2h-4v14a2 2 0 0 1-2 2', key: '8o2wsi' }],
  ['path', { d: 'M18 10h4', key: '1fqhjb' }],
  ['circle', { cx: '4.5', cy: '21.5', r: '.5', key: '1ppawi' }],
  ['path', { d: 'M3 17.5h.01', key: '1fgdjy' }],
];

export default maskSnorkel;
